import developers from "../developers";
import tags from "../tags";

// icons
import akademyatiIcon from "../../assets/apps/icons/akademyati.png";

// images
import akademyatiCover from "../../assets/apps/images/akademyati/cover.png";
import akademyatiImage1 from "../../assets/apps/images/akademyati/1.png";
import akademyatiImage2 from "../../assets/apps/images/akademyati/2.png";
import akademyatiImage3 from "../../assets/apps/images/akademyati/3.png";
import akademyatiImage4 from "../../assets/apps/images/akademyati/4.png";
import akademyatiImage5 from "../../assets/apps/images/akademyati/5.png";
import akademyatiImage6 from "../../assets/apps/images/akademyati/6.png";
import akademyatiImage7 from "../../assets/apps/images/akademyati/7.png";
import akademyatiImage8 from "../../assets/apps/images/akademyati/8.png";
import akademyatiImage9 from "../../assets/apps/images/akademyati/9.png";
import akademyatiImage10 from "../../assets/apps/images/akademyati/10.png";
import akademyatiImage11 from "../../assets/apps/images/akademyati/11.png";
import akademyatiImage12 from "../../assets/apps/images/akademyati/12.png";
import akademyatiImage13 from "../../assets/apps/images/akademyati/13.png";
import akademyatiImage14 from "../../assets/apps/images/akademyati/14.png";
import akademyatiImage15 from "../../assets/apps/images/akademyati/15.png";
import akademyatiImage16 from "../../assets/apps/images/akademyati/16.png";

export const akademyati = {
    title: "Akademyati Education Platform",
    slug: "akademyati-education-platform",
    url: "https://akademyati.com",
    description: `
### Overview
Akademyati is a full-featured online learning platform built with Laravel, designed to deliver a modern and interactive educational experience. The project provides a complete environment where students can explore courses, instructors can create structured learning content, and administrators can manage the entire ecosystem through powerful dashboards.

It is not just a course website — Akademyati is a scalable learning management system (LMS) that focuses on organization, usability, and real academic workflows.

---

### Purpose & Vision
The main goal of Akademyati is to create a digital education space that connects learners and instructors in a structured and engaging way. The platform supports the full learning journey:

- Discovering and enrolling in courses  
- Following organized learning paths  
- Building course content step-by-step  
- Tracking progress through dashboards  
- Enabling communication between users  

Akademyati is built as a senior-level academic project with real-world LMS architecture in mind.

---

### User Experience & Platform Design
Akademyati emphasizes clean UI structure and user-friendly navigation across all roles. Each type of user has a personalized experience:

- Students see learning-focused dashboards  
- Instructors access course-building tools  
- Admins control the platform through management panels  

The interface is designed to feel modern, intuitive, and scalable for future expansion.

---

### Core Features & System Modules

#### Role-Based Accounts & Profiles
Akademyati supports multiple user roles with dedicated functionality:

- Student accounts with enrolled course tracking  
- Instructor accounts with publishing tools  
- Administrator accounts with full platform control  

Each user has a profile system including personal details, learning activity, and course engagement.

---

#### Course Creation & Instructor Studio
One of the strongest parts of Akademyati is the instructor course-building workflow.

Instructors can create courses through a structured multi-stage process:

- Course foundation setup (title, category, objectives)  
- Curriculum design with sections, units, and lectures  
- Uploading promotional content (image + intro video)  
- Preparing the course for publishing  

The course builder is designed to feel professional and similar to real platforms like Udemy or Coursera.

---

#### Structured Curriculum System
Akademyati introduces a clear hierarchical learning structure:

- Units  
- Sections  
- Lectures  

Lectures can support multiple content types such as:

- Video lectures  
- Article-based lessons  
- Assignments  
- Quizzes  
- Surveys  
- Downloadable resources  

This modular design makes the platform flexible and expandable.

---

#### Course Versioning & History Tracking
Akademyati includes an advanced concept of course evolution through versioning.

Instructors can update courses over time while maintaining:

- Previous versions of course content  
- Curriculum history and changes  
- Structured improvement cycles  

This feature supports long-term course development and professional content management.

---

#### Student Learning Dashboard
Students receive a personalized dashboard experience that includes:

- Current enrolled courses  
- Progress tracking  
- Saved learning content  
- Quick access to ongoing lectures  

The dashboard is built to keep learners focused and motivated.

---

#### Explore & Course Discovery
Akademyati provides an Explore system where users can browse courses through:

- Categories and subject filtering  
- Course previews and promotional pages  
- Instructor profiles and published content  
- Search-friendly navigation  

This makes the platform feel like a real educational marketplace.

---

#### Communication & User Interaction
The platform also supports communication features that strengthen the learning environment:

- Chat and messaging between users  
- Instructor-student interaction channels  
- Discussion-oriented learning support  

These tools help build a connected educational community.

---

#### Administrative Management Dashboard
Akademyati includes an admin control layer where administrators can manage:

- Users and roles  
- Course approval and monitoring  
- Platform content organization  
- System-wide analytics and control  

This ensures the platform can scale with structured governance.

---

### Technology & Development Approach
Akademyati is built using Laravel with a focus on clean backend architecture, database normalization, and scalable development practices.

Key technical highlights include:

- Prototype-based development methodology  
- Dynamic curriculum saving with structured database tables  
- Separate handling of lecture types for maintainability  
- Responsive UI components and reusable layouts  

The project demonstrates strong full-stack engineering and real LMS system planning.

---

### Summary
Akademyati is a complete learning management platform that combines course creation, structured curriculum delivery, dashboards, user communication, exploration tools, and version-controlled course development.

It represents a large-scale academic and professional project built with Laravel, showcasing both technical depth and product-level vision.

Akademyati is not only a learning platform — it is a foundation for a future-ready digital education ecosystem.
`,
    tags: [
        tags.laravel,
        tags.php,
        tags.mysql,

        tags.html,
        tags.css,
        tags.bootstrap,
        tags.javascript,

        tags.auth,
        tags.authorization,
        tags.crud,
        tags.validation,

        tags.dashboard,
        tags.cms,
        tags.search,
        tags.chat,
        tags.notifications,

        tags.fullstack,
        tags.webApp,

        tags.edu,
    ],
    icon: akademyatiIcon,
    cover: akademyatiCover,
    badge: "Laravel",
    images: [
        akademyatiImage1,
        akademyatiImage2,
        akademyatiImage3,
        akademyatiImage4,
        akademyatiImage5,
        akademyatiImage6,
        akademyatiImage7,
        akademyatiImage8,
        akademyatiImage9,
        akademyatiImage10,
        akademyatiImage11,
        akademyatiImage12,
        akademyatiImage13,
        akademyatiImage14,
        akademyatiImage15,
        akademyatiImage16,
    ],
    github: "https://github.com/bilalabdulhadii/akademyati-laravel",
    developer: developers.bilalabdulhadii,
};
